import { useRequestURL, useRouter } from '#imports'
import { type Ref, computed } from 'vue'

import type { GetProductResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/product'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { toNuxtLink } from '@backmarket/nuxt-module-navigation/toNuxtLink'
import { toBcp47Locale } from '@backmarket/utils/string/toBcp47Locale'

import { PRODUCT } from '~/scopes/product-core/route-names'

export function useProductCanonicalUrl({
  productResponse,
}: {
  productResponse: Ref<GetProductResponse | undefined>
}) {
  const i18n = useI18n()
  const router = useRouter()
  const { protocol, hostname } = useRequestURL()
  const locale = toBcp47Locale(i18n.currentLocale)

  const canonicalUrl = computed(() => {
    if (!productResponse.value) {
      return ''
    }

    const route = productResponse.value.parentProductSlug
      ? toNuxtLink({
          name: PRODUCT.MASTER_PP,
          params: { locale, slug: productResponse.value.parentProductSlug },
        })
      : toNuxtLink({
          name: PRODUCT.HOME,
          params: {
            locale,
            slugV2: productResponse.value.seo.slug,
            uuid: productResponse.value.productId,
          },
        })

    return `${protocol}//${hostname}${router.resolve(route).href}`
  })

  return { canonicalUrl }
}
